"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textDecorationHelperStyle = exports.TextDecorationHelperArray = void 0;

var _grid = require("../grid");

var TextDecorationHelperArray = ['blink', 'line-through ', 'overline', 'underline', 'none', 'inherit'];
exports.TextDecorationHelperArray = TextDecorationHelperArray;

var textDecorationHelperStyle = function textDecorationHelperStyle(textDecoration) {
  return (0, _grid.map)(textDecoration, function (a) {
    return "text-decoration: ".concat(a, " !important;");
  });
};

exports.textDecorationHelperStyle = textDecorationHelperStyle;